import { Flex } from 'antd'
import { FC, ReactNode, useContext, useState } from 'react'
import ToolingCostCheckbox from '../../../../../components/tooling-cost-checkbox/tooling-cost-checkbox'
import Shipment from '../../../../../types/api/shipment'
import {
    canToggleShipmentTooling,
    isShipmentToolingIncluded,
    ToolingKind,
} from '../../../helpers/tooling-inclusion'
import { ShipmentsPageCtx } from '../../../shipments-page'

interface ShipmentToolingCostCellProps {
    shipment: Shipment
    kind: ToolingKind
    value: ReactNode
}

const ShipmentToolingCostCell: FC<ShipmentToolingCostCellProps> = ({ shipment, kind, value }) => {
    const { onSetToolingIncluded } = useContext(ShipmentsPageCtx)
    const [pending, setPending] = useState(false)
    const included = isShipmentToolingIncluded(shipment, kind)

    const handleChange = async (nextIncluded: boolean) => {
        setPending(true)
        try {
            await onSetToolingIncluded(shipment, kind, nextIncluded)
        } finally {
            setPending(false)
        }
    }

    return (
        <Flex align='center' gap={4}>
            {value}
            <ToolingCostCheckbox
                included={included}
                disabled={pending || !canToggleShipmentTooling(shipment, kind)}
                onChange={handleChange}
            />
        </Flex>
    )
}

export default ShipmentToolingCostCell
